import React from 'react';

const About = () => {
    return (
        <section id="about" className="about-section">
            <div className="container">
                <div className="section-header fade-in">
                    <p className="eyebrow">About AI Consulting SA</p>
                    <h2>Local market context, enterprise engineering discipline, and AI strategy under one roof.</h2>
                    <p>We help South African organizations turn AI ambition into governed, adopted systems that stand up in production.</p>
                </div>

                <div className="about-grid">
                    <div className="about-text fade-in">
                        <h3>Built for the realities of African businesses.</h3>
                        <p>
                            Since 2018, our team has partnered with leadership, data, and operations teams to identify high-value AI opportunities and deliver them with clear ownership.
                        </p>
                        <p>
                            We combine strategic advisory, machine learning delivery, and change enablement so AI programs do not stall between a promising pilot and day-to-day adoption.
                        </p>

                        <dl className="about-stats" aria-label="Company strengths">
                            <div>
                                <dt>2018</dt>
                                <dd>Founded in South Africa</dd>
                            </div>
                            <div>
                                <dt>6</dt>
                                <dd>Core AI service lines</dd>
                            </div>
                            <div>
                                <dt>3</dt>
                                <dd>Delivery pillars: strategy, build, enablement</dd>
                            </div>
                        </dl>
                    </div>

                    <div className="mission-vision fade-in">
                        <div className="mission">
                            <h4><i className="fas fa-bullseye" aria-hidden="true"></i> Mission</h4>
                            <p>Help African businesses deploy AI that improves growth, efficiency, resilience, and customer experience.</p>
                        </div>
                        <div className="vision">
                            <h4><i className="fas fa-eye" aria-hidden="true"></i> Vision</h4>
                            <p>A market where practical AI strengthens human judgment and expands economic opportunity.</p>
                        </div>
                    </div>

                    <div className="about-timeline fade-in">
                        <div className="timeline">
                            <div className="timeline-item">
                                <div className="timeline-year">2018</div>
                                <div className="timeline-content">
                                    <h4>Company Founded</h4>
                                    <p>Started with a mandate to bring senior AI expertise to South African organizations.</p>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="timeline-year">2021</div>
                                <div className="timeline-content">
                                    <h4>Production Delivery</h4>
                                    <p>Expanded beyond advisory into custom ML systems, automation, and analytics platforms.</p>
                                </div>
                            </div>
                            <div className="timeline-item">
                                <div className="timeline-year">2024</div>
                                <div className="timeline-content">
                                    <h4>AI Innovation Hub</h4>
                                    <p>Launched a Cape Town research and delivery hub for applied AI programs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
